import { ExternalInterfacesService } from './../../external-interfaces/external-interfaces.service';
import { Inject, Injectable } from '@angular/core';
import { ProcessTypeEnum } from '../../models/cartDetails/process-type.enum';
import SsoAuthService from './sso-auth.service';
import { LeadsSupportService } from './leads-support.service';
import SlotStateService from '../../cart-process/slot-state.service';
import { CustomerDetailsModel } from '../../models/customer-details.model';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import PageValidateModel from '../../models/page-validate.model';
import { CommonModalService } from '../../utils/modals/common-modal.service';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';

@Injectable()
export default class OtherProcessAuthService {

  private bundleNumber: number;
  private msisdn: string;
  private resolve: Function;
  private reject: Function;


  constructor(
    private ssoAuthService: SsoAuthService,
    private leadsService: LeadsSupportService,
    private slotStateService: SlotStateService,
    private notificationProvider: NotificationProviderService,
    private commonModalService: CommonModalService,
    private externalInterfacesService: ExternalInterfacesService,
    @Inject('Endpoint') private endpoint: any,
  ) {
  }


  public startProcess(bundleNumber: number, msisdn: string, processType: ProcessTypeEnum): Promise<any> {
    let promise = new Promise((_resolve: Function, _reject: Function) => {
      this.resolve = _resolve;
      this.reject = _reject;
    });

    this.bundleNumber = bundleNumber;
    this.msisdn = msisdn;
    this.ssoAuthService.startProcess(bundleNumber, msisdn, processType)
      .then(
        this.handleAuthSuccess.bind(this),
        this.handleAuthFailure.bind(this)
      );

    return promise;
  }

  private handleAuthSuccess(): void {
    this.endpoint('newCart.validateCart')
      .run()
      .then((validationResponse: any) => {
        if (validationResponse.status === 205) {
          this.externalInterfacesService.updateCartDetails();
          return;
        }

        this.commonModalService.removeModal(CommonModalTemplatesEnum.NUMBER_VERIFICATION_SMS);

        this.handleValidationResponse(validationResponse.body);
      })
      .catch(() => {
        this.handleFailure();
      });
  }

  private handleAuthFailure(errorMessage: string): void {
    this.reject(errorMessage);
  }

  private handleValidationResponse(validationResponse: any): void {
    this.notificationProvider.publish(
      NotificationProviderTypeEnum.PAGE_VALIDATION_CART,
      new PageValidateModel(Object.assign(validationResponse, {_source: 'authService'}))
    );

    const response = validationResponse;
    const slotTempState = this.slotStateService.getTempState(this.bundleNumber);

    if (response.analyticalData) {
      window['dataLayer'].push(response.analyticalData);
    }

    if (response.redirectUrl) {
      window.location.href = '/' + response.redirectUrl;

      this.reject();

      return;
    }

    if (response.cartDetails) {
      this.notificationProvider.publish(
        NotificationProviderTypeEnum.CART_DETAILS,
        response.cartDetails
      );
    }

    if (response.showLead) {
      this.leadsService.startLeads({msisdn: this.msisdn});

      this.reject();

      return;
    }

    slotTempState.UPSELL_EDIT_STATE = false;
    slotTempState.RETENTION_EDIT_STATE = false;
    slotTempState.PREPAID_2_POSTPAID_EDIT_STATE = false;

    // this.commonModalService.removeModal();

    this.endpoint('customer.customerData').run()
      .then(
        (response: any) => {
          if (response) {
            this.notificationProvider.publish(
              NotificationProviderTypeEnum.CUSTOMER_DETAILS,
              new CustomerDetailsModel(response.response)
            );
          }
        }
      )
      .catch(
        () => {
        }
      );

    this.resolve();
  }

  private handleFailure(): void {
    this.ssoAuthService.showFailureModal();
    this.reject();
  }

}
